module.exports = __webpack_public_path__ + "img/p003.2efb4857.png";